import { call, put, delay } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import {
  loadDriverLogAllSuccessful, loadDriverLogAllFailed, loadDriverLogAllBegin,
} from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL_V2 } from '../../../configs';
import { getExistFields } from '../../../utils/utils';

export default function* loadDriverLogListAll(action) {
  try {
    const { payload = {} } = action;
    const {
      filter,
    } = payload;
    let pool = {};
    if (typeof filter === 'object' && Object.keys(filter).length) {
      pool = { ...pool, ...getExistFields(filter) };
    }
    yield put(loadDriverLogAllBegin());
    const url = `${BACKEND_URL_V2}/dict/drivers/all`;

    const dataResponse = yield makeRequest(url, pool, action, 'GET', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(loadDriverLogAllSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadDriverLogAllFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(loadDriverLogAllFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  } finally {
    yield call(resolveActionPromise(action));
  }
}
